import React from 'react';

import EvaluacionNivelView from '../components/evaluaciones/EvaluacionNivelView';
import { obtenerModulosNivel } from '../config/evaluacionesCatalogo';
import M11_Ejercicio7 from '../components/evaluaciones/Avanzado/Modulo11/M11_Ejercicio7';
import M11_Ejercicio8 from '../components/evaluaciones/Avanzado/Modulo11/M11_Ejercicio8';
import M11_Ejercicio9 from '../components/evaluaciones/Avanzado/Modulo11/M11_Ejercicio9';
import M11_Ejercicio10 from '../components/evaluaciones/Avanzado/Modulo11/M11_Ejercicio10';
import M12_Ejercicio6 from '../components/evaluaciones/Avanzado/Modulo12/M12_Ejercicio6';
import M13_Ejercicio7 from '../components/evaluaciones/Avanzado/Modulo13/M13_Ejercicio7';
import M14_Ejercicio7 from '../components/evaluaciones/Avanzado/Modulo14/M14_Ejercicio7';
import M14_CuadroSinoptico from '../components/evaluaciones/Avanzado/Modulo14/M14_CuadroSinoptico';
import M14_ColumnasCuadroSinoptico from '../components/evaluaciones/Avanzado/Modulo14/M14_ColumnasCuadroSinoptico';
import M15_Ejercicio6 from '../components/evaluaciones/Avanzado/Modulo15/M15_Ejercicio6';
import M15_Ejercicio7 from '../components/evaluaciones/Avanzado/Modulo15/M15_Ejercicio7';
import M15_MetodoLectura from '../components/evaluaciones/Avanzado/Modulo15/M15_MetodoLectura';
import M15_VerificacionAtencion from '../components/evaluaciones/Avanzado/Modulo15/M15_VerificacionAtencion';

const componentes = {
  avanzado_modulo11_7: M11_Ejercicio7,
  avanzado_modulo11_8: M11_Ejercicio8,
  avanzado_modulo11_9: M11_Ejercicio9,
  avanzado_modulo11_10: M11_Ejercicio10,
  avanzado_modulo12_126: M12_Ejercicio6,
  avanzado_modulo13_137: M13_Ejercicio7,
  avanzado_modulo14_147: M14_Ejercicio7,
  avanzado_modulo14_148: M14_CuadroSinoptico,
  avanzado_modulo14_149: M14_ColumnasCuadroSinoptico,
  avanzado_modulo15_156: M15_Ejercicio6,
  avanzado_modulo15_157: M15_Ejercicio7,
  avanzado_modulo15_158: M15_MetodoLectura,
  avanzado_modulo15_159: M15_VerificacionAtencion,
};

const modulos = obtenerModulosNivel('avanzado', componentes);

const EvaluacionAvanzada = () => (
  <EvaluacionNivelView nivel="avanzado" titulo="Nivel 3 Avanzado" modulos={modulos} />
);

export default EvaluacionAvanzada;
